/**
 * @generated SignedSource<<d4eb4ef7d8580428bb126f1d2b36abb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dataToSet"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "frameId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadataHasChanged"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dataToSet",
        "variableName": "dataToSet"
      },
      {
        "kind": "Variable",
        "name": "frameId",
        "variableName": "frameId"
      },
      {
        "kind": "Variable",
        "name": "metadataHasChanged",
        "variableName": "metadataHasChanged"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateFrame",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateFrameMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateFrameMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "df1860fe9a12fe0bf659472f54d5052d",
    "id": null,
    "metadata": {},
    "name": "UpdateFrameMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateFrameMutation(\n  $frameId: ID!\n  $dataToSet: FrameInput!\n  $metadataHasChanged: Boolean!\n) {\n  updateFrame(frameId: $frameId, dataToSet: $dataToSet, metadataHasChanged: $metadataHasChanged) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "09c21f8f5816d7066a0924cb472f1aab";

export default node;
